import React from 'react';
import classNames from 'classnames';
import './Badge.scss';

const Badge = props => {
  const {
    children,
    extraClassNames,
    notification,
    show,
    rank,
    bullet,
    error,
    completed,
    tag,
    inButton,
    large,
    onListItem,
    style
  } = props;
  return (
    <span
      className={classNames('c-badge', extraClassNames, {
        'c-badge--notification': notification,
        'c-badge--show': show,
        'c-badge--rank': rank,
        'c-badge--bullet': bullet,
        'c-badge--error': error,
        'c-badge--completed': completed,
        'c-badge--tag': tag,
        'c-badge--in-button': inButton,
        'c-badge--large': large,
        'c-badge--on-list-item': onListItem
      })}
      style={style}
    >
      {children}
    </span>
  );
};

export default Badge;
